export const getNativeConfig = () => {
  return {
    native: {
      allowNavigation: ['*.sdui.dev', '*.sdux.de', 'sdui.app', 'iam.sdui-group.app'],
      appName: 'OSS Messenger',
      packageName: 'com.sdui.oss',
      defaultUrl: 'https://sdui.app',
      android: {
        flavor: 'oss'
      },
      ios: {
        Scheme: 'OSS'
      }
    }
  }
}
